var _path, _line, _line2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrofone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Clipe de voz",
    className: "input-icon-img",
    fill: "currentColor",
    height: 22,
    role: "img",
    viewBox: "0 0 24 24",
    width: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    fill: "#F9F9F9",
    id: titleId
  }, "Clipe de voz") : title ? /*#__PURE__*/React.createElement("title", {
    fill: "#F9F9F9",
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.671v.897a7.5 7.5 0 0 1-15 0v-.897",
    fill: "none",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F9F9F9",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    x1: 12,
    x2: 12,
    y1: 19.068,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    x1: 8.706,
    x2: 15.104,
    y1: 22,
    y2: 22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.745a4 4 0 0 1-4-4V6a4 4 0 0 1 8 0v5.745a4 4 0 0 1-4 4Z",
    fill: "none",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrofone);
export default __webpack_public_path__ + "static/media/microfone.ff8ee9b5f3ebdd5c81ec7d220dd1c32f.svg";
export { ForwardRef as ReactComponent };